const Header = ({ children }) => {
  return <div className="fixed w-full border-b border-gray-200 bg-white z-100">{children}</div>;
};

export default Header;
